import { HttpContext, HttpContextToken } from '@angular/common/http';

export const DEMO_MODULE = new HttpContextToken<string | null>(() => null);

export function withDemoModule(moduleName: string): { context: HttpContext } {
  return {
    context: new HttpContext().set(DEMO_MODULE, moduleName)
  };
}